<h2>
  {{ title }}
  <span *ngIf="model.Id" title="Bundle Definition Id">- {{ model.Id }}</span>
  <span *ngIf="model.Name">- {{ model.Name }}</span>
</h2>
<hr />

<div class="divrel">
  <form (ngSubmit)="onSubmit()" #payerForm="ngForm" class="editForm" novalidate [ngBusy]="busy">
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label class="control-label">Name</label>
          <input
            type="text"
            class="form-control"
            name="Name"
            [(ngModel)]="model.Name"
            #Name="ngModel"
            required
          />
          <app-tooltip [form]="'payer'" [uid]="'Name'"></app-tooltip>
        </div>
      </div>

      <div class="col-md-3">
        <div class="form-group">
          <label class="control-label">Episode Type Name</label>
          <input
            type="text"
            class="form-control"
            name="EpisodeTypeName"
            [(ngModel)]="model.EpisodeTypeName"
            #EpisodeTypeName="ngModel"
            required
          />
        </div>
      </div>

      <div class="col-md-3">
        <div class="form-group">
          <label class="control-label">Description</label>
          <input
            type="text"
            class="form-control"
            name="Description"
            [(ngModel)]="model.Description"
            #Description="ngModel"
            required
          />
        </div>
      </div>

      <div class="col-md-3">
        <div class="check-form-group">
          <div class="check">
            <input type="checkbox" id="AtRisk" name="AtRisk" [(ngModel)]="model.AtRisk" />
            <label for="AtRisk"></label>
          </div>
          <label for="AtRisk">At Risk</label>
        </div>
      </div>

      <div class="col-md-3">
        <div class="form-group">
          <label class="control-label">Diagnosis Related Group</label>
          <app-select
            #refDiagnosisRelatedGroupList
            [items]="refDiagnosisRelatedGroupOptions"
            [allowClear]="false"
            [selected]="selectRefDiagnosisRelatedGroup"
            [removed]="selectRefDiagnosisRelatedGroup"
            placeholder="Select a Diagnosis Related Group"
          >
          </app-select>
        </div>
      </div>
    </div>

    <hr />
    <div class="row">
      <button class="btn btn-default pull-right" type="button" (click)="backToList()">
        Back to list
      </button>
      <button type="submit" class="btn btn-success pull-right">Save</button>
    </div>
  </form>
</div>
